import { getTodayLocal } from './get-today-local';

/**
 * Returns a Date object set to local midnight N days before today.
 * Handles month and year boundaries automatically.
 *
 * @example
 * // Today locally is 2026-05-27
 * getDateLocalAgoDays(29)  // → 2026-04-28T00:00:00.000 (local)
 * getDateLocalAgoDays(1)   // → 2026-05-26T00:00:00.000 (local)
 */
export const getDateLocalAgoDays = (days: number): Date => {
  const date = getTodayLocal();
  date.setDate(date.getDate() - days);
  return date;
};
